import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";

export default function Unsubscribe() {
  const tokenRef = useRef(
    new URLSearchParams(window.location.search).get("token") || ""
  );
  const [hasToken] = useState(Boolean(tokenRef.current));
  const [done, setDone] = useState(false);

  useEffect(() => {
    // Strip the token from the visible URL immediately; keep it in memory only.
    if (tokenRef.current) window.history.replaceState(null, "", "/newsletter/unsubscribe");
  }, []);

  const unsub = async () => {
    try {
      await api.post("/public/newsletter/unsubscribe", { token: tokenRef.current, all: true });
      setDone(true);
      toast.success("You have been unsubscribed from all newsletters.");
    } catch { toast.error("This link is invalid or expired."); }
  };
  const goManage = () => {
    window.location.href = `/newsletter/manage?token=${encodeURIComponent(tokenRef.current)}`;
  };

  if (!hasToken) return <div className="max-w-lg mx-auto px-4 py-24 text-center text-ink/60">Invalid link.</div>;

  return (
    <div className="max-w-lg mx-auto px-4 sm:px-6 py-20 text-center" data-testid="unsubscribe-page">
      <title>Unsubscribe | Be-Apuo</title>
      <meta name="referrer" content="no-referrer" />
      <div className="label-caps text-clay">Newsletter</div>
      {done ? (
        <div data-testid="unsub-done">
          <h1 className="mt-2 font-editorial font-black text-3xl text-ink">You're unsubscribed</h1>
          <p className="mt-3 text-ink/60">You will no longer receive Be-Apuo newsletters. You can re-subscribe anytime.</p>
          <Link to="/" className="inline-block mt-6 bg-heritage text-paper px-5 py-2.5 text-sm font-semibold hover:bg-heritage/90 transition-colors">Back to home</Link>
        </div>
      ) : (
        <div>
          <h1 className="mt-2 font-editorial font-black text-3xl text-ink">Unsubscribe from all?</h1>
          <p className="mt-3 text-ink/60">You can also manage individual newsletters instead of unsubscribing from everything.</p>
          <div className="mt-6 flex gap-3 justify-center">
            <button data-testid="confirm-unsub-btn" onClick={unsub}
              className="bg-clay text-paper px-5 py-2.5 text-sm font-semibold hover:bg-clay/90 transition-colors">Unsubscribe from all</button>
            <button data-testid="go-manage-btn" onClick={goManage}
              className="border border-ink text-ink px-5 py-2.5 text-sm font-semibold hover:bg-ink hover:text-paper transition-colors">Manage preferences</button>
          </div>
        </div>
      )}
    </div>
  );
}
